module.exports = __webpack_public_path__ + "static/media/8604-l-en.1a6c0b9d.png";